import { useEffect, useRef } from "react"
import "../css/Video.css"

const VideoPlayer = ({ video }) => {
  const videoRef = useRef(null)

  useEffect(() => {
    if (videoRef.current && video) {
      const videoElement = videoRef.current

      // Add error handler
      const handleError = (e) => {
        console.error("Video error:", {
          error: videoElement.error,
          errorCode: videoElement.error?.code,
          errorMessage: videoElement.error?.message,
          networkState: videoElement.networkState,
          readyState: videoElement.readyState,
        })
      }

      videoElement.addEventListener("error", handleError)

      // Set the src and load
      videoElement.src = video
      videoElement.type = "video/mp4"
      videoElement.load()

      // Try to play (might be blocked by browser autoplay policy but worth trying)
      const playPromise = videoElement.play()
      if (playPromise !== undefined) {
        playPromise.catch((err) => {
          console.error("Play error:", err.message)
        })
      }

      return () => {
        videoElement.removeEventListener("error", handleError)
      }
    }
  }, [video])

  return (
    <article className="container-video">
      <video
        ref={videoRef}
        autoPlay
        controls
        muted
        preload="metadata"
        className="controls"
      >
        Your browser does not support the video tag.
      </video>
    </article>
  )
}

export default VideoPlayer
